import { Box, Divider, Stack, Typography } from "@mui/material";
import { Button, SelectField } from "components";
import {
  useGetCustomerGeneralSettings,
  useUpdateCustomerGeneralSettings,
} from "controller";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { TimeZoneList } from "shared";
import { useForm, useWatch } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import toast from "react-hot-toast";

const schema = yup.object({
  timezone: yup.string().required("Time zone is required"),
});
interface Params {
  id?: string | undefined;
}
const GeneralSettingsTab = () => {
  const [isEdited, setIsEdited] = useState(false);
  const { id }: Params = useParams();
  const { data: generalSettingsData } = useGetCustomerGeneralSettings(id || "");

  const { mutateAsync: updateCustomerGeneralSettings } =
    useUpdateCustomerGeneralSettings();

  const {
    handleSubmit,
    control,
    reset,
    formState: { isDirty, dirtyFields, errors },

    setValue,
    watch,
  } = useForm({
    defaultValues: {
      timezone: generalSettingsData?.timezone || "",
    },
    resolver: yupResolver(schema),
  });
  useEffect(() => {
    if (generalSettingsData) {
      setValue("timezone", generalSettingsData?.settings?.timezone || "");
    }
  }, [generalSettingsData]);

  useEffect(() => {
    if (isDirty) {
      setIsEdited(true);
    }
  }, [isDirty]);

  const handleSave = handleSubmit(async (data) => {
    try {
      setIsEdited(false);
      const update = await updateCustomerGeneralSettings({
        bodyData: data,
        customerId: id,
      });
      if (update) {
        toast.success("General settings updated successfully");
      }
    } catch (err) {
      console.log(err);
      toast.error("Unable to update general settings at the moment");
    }
  });
  return (
    <Stack
      sx={{
        height: "100%",
        overflowY: "clip",
      }}
    >
      <Box sx={{ flex: "1", overflowY: "scroll" }}>
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          padding={"0px 32px 0px 32px"}
        >
          <Typography>TIme Zone</Typography>
          <Box
            sx={{
              width: "281px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "12px",
            }}
          >
            <SelectField
              name="timezone"
              label="Time Zone"
              isSearchable
              // value={time}
              control={control}
              isGrouped={true}
              groupedOptions={TimeZoneList}
              disabled={false}
              labelMappingKey="label"
              valueMappingKey="value"
              // onValueChange={(newValue) =>
              //   handleFieldChange({ field: "timezone", value: newValue })
              // }
              errorMessage={errors?.timezone && "Time zone is required"}
            />
          </Box>
        </Stack>
        <Divider />
      </Box>

      <Box
        sx={{
          width: "100%",
          borderTop: "1px solid rgba(0, 0, 0, 0.12)",
          padding: "16px",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Box sx={{ marginRight: "20px" }}>
          <Button
            size="medium"
            variant="primary"
            onClick={() => handleSave()}
            disabled={!isEdited}
          >
            Save
          </Button>
        </Box>
      </Box>
    </Stack>
  );
};

export default GeneralSettingsTab;
